export const FETCH_ORGANISATIONS = 'FETCH_ORGANISATIONS';

import { getOrganisations } from '../api';

export const fetchOrganisations = () => {
  return {
    type: FETCH_ORGANISATIONS,
    payload: getOrganisations()
  }
}



// WEBPACK FOOTER //
// ./src/actions/organisations.js